module.exports = __webpack_public_path__ + "static/media/close-thin.562ffba0.svg";